import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { AxiosPromise } from "axios";
import { axios } from "utils";

const getCompanyNameList = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    method: "GET",
    url: "/jobs/applied/company-name",
  });
};

export const useGetCompanyNameListQuery = (): UseQueryResult<
  unknown,
  unknown
> => {
  return useQuery([""], getCompanyNameList, {
    enabled: true,
  });
};
